import logo from "@/assets/images/logo.svg";

const Logo = () => {
  return <img className="logo" src={logo} alt="Jobify" width={164} height={50} />;
};

export default Logo;
